import React from 'react';
import { GeneralLayout } from '../../../components/layout/GeneralLayout/GeneralLayout';
import { getCandidateConfig } from '../../../../config/candidates';

export const PolicyDataPage: React.FC = () => {
  const candidateName = process.env.REACT_APP_CANDIDATE_NAME || "default";
  const candidateConfig = getCandidateConfig(candidateName);

  return (
    <GeneralLayout>
      <div className="card w-full max-w-screen-lg">
        <h1 className="text-2xl sm:text-3xl font-bold text-center text-gray-900 mb-2">POLÍTICA DE TRATAMIENTO DE DATOS PERSONALES Y HÁBEAS DATA</h1>
        {candidateConfig.policy}
      </div>
    </GeneralLayout>
  );
};
